import React from 'react'

export const CalendarDateCardSettings = (settingsProps) => {
  return (
    <>
      <div className="empty-message">
        <p>No options available</p>
      </div>
    </>
  )
}

export const CalendarDateCardFloatingSettings = () =>
  React.createElement(CalendarDateCardSettings, { floating: true })
